import { createSelector } from 'reselect'

const getRecursionRule = (rules, ruleId) => rules.find(rule => rule.id === ruleId);
export const makeGetRecursionRule = () => createSelector(getRecursionRule, rules => rules);
